/**
 * enrichPending.ts — whether the open panel is still waiting for its
 * enrichment (Wikipedia, Wikidata, Commons), as React context.
 *
 * DetailPanel provides it from useEnrichment; DetailSheetWrapper reads it to
 * hold the body back until the text and pictures have arrived, at most 1.5 s,
 * so they do not push the panel down one after another. A /s/ page shifted
 * by 0.88 (CLS) on a phone that way, measured 1 Oct 2026. Modals that use the
 * wrapper have no provider and render at once.
 */
import { createContext } from "react";

export const EnrichPendingContext = createContext(false);
